export const getAuthToken = () => {
    return localStorage.getItem('authToken');
}

export const setAuthToken = (value: string) => {
    return localStorage.setItem('authToken', value);
}

export const removeAuthToken = () => {
    return localStorage.removeItem('authToken');
}
